export default __webpack_public_path__ + "static/media/wegovy-inject-remove-needle.0b264cd5.mp4";